import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Download — statement PDF / Excel export. */
export function DownloadIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M12 4v10.5M7.5 10.5 12 15l4.5-4.5" />
      <path d="M4.5 18.5h15" />
    </PortalIcon>
  );
}
